import { Checkbox, FormControlLabel } from "@mui/material";

function CheckboxInput({ label, value, disabled, onChange, style }: any) {
  return (
    <FormControlLabel
      control={<Checkbox onChange={onChange} checked={value} style={style} />}
      label={label}
      value={value}
      disabled={disabled}
      sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
    />
  );
}

export default CheckboxInput;
